import { render, staticRenderFns } from "./code-preview.vue?vue&type=template&id=48834312&"
import script from "./code-preview.vue?vue&type=script&lang=ts&"
export * from "./code-preview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports